import { BaseText, type BaseTextProps } from "~/components/layout/text/BaseText";

export type NoRecordsProps = {
    emptyText?: string;
} & BaseTextProps;

export const NoRecords = ({
    size = "sm",
    colour = "secondary",
    weight = "semibold",
    decoration = "italic",
    emptyText = "No records",
    children,
    ...textProps
}: NoRecordsProps) => {
    return (
        <BaseText
            {...textProps}
            size={size}
            colour={colour}
            weight={weight}
            decoration={decoration}
            lineBreakStrategyIOS="standard"
        >
            {children ?? emptyText}
        </BaseText>
    );
};
